<div class="light-theme">
    <div class="border-bottom" *ngIf="!ownProfile">
        <div class="container-fluid ">
            <div class="row align-items-center">
                <div class="col-auto border-right">
                    <a href="dashboard/community">
                        <div class="svg-btn py-3">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 18L9 12L15 6" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <div class=" py-3">My Community</div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row profile">
            <div class="col-12 col-lg-4 profile-header">
                <div class="row align-items-start h-100">
                    <div
                        class="col-12 col-md-auto col-lg-12 py-4 d-flex justify-content-center oder-1 order-md-2 order-lg-3 align-self-lg-end">
                        <a class="btn btn-secondary" [routerLink]="getProfileLink()" *ngIf="ownProfile">Edit profile</a>
                    </div>
                    <div
                        class="col-12 col-md-8 col-lg-12 text-center text-md-left text-lg-center justify-content-lg-center order-2 order-md-1 order-lg-1 pt-5">
                        <img src="{{user?.userImageData ? user.userImageData : 'https://equityisdynamic-static.s3.amazonaws.com/misc/profile.png'}}"
                            class="img-fluid profile-img">
                        <h1 class="py-3">{{user.firstName}} {{user.lastName}}</h1>
                    </div>
                    <div
                        class="col-12 col-md-6 col-lg-12 text-center text-md-left text-lg-center justify-content-lg-center  order-3 order-md-3 order-lg-2 pb-5 pb-md-4">
                        <div class="subtitle">{{user.companyRol}}</div>
                        <div class="subtitle text-blue">{{user.company}}</div>
                        <div class="text-large pt-3"><i class="fas fa-map-marker-alt pr-2"></i>{{user.location}}</div>
                        <div class="py-3">
                            <span class="badge footnote badge-primary mr-2"
                                *ngFor="let sector of user.sectors">{{sector.name}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 d-lg-none order-4 px-0 px-md-3">
                        <div class="dark-theme pl-4">
                            <status [userStatus]="userStatus" [activitiesCount]="activitiesCount"></status>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8 profile-detail light-theme-alt d-flex flex-column justify-content-between">
                <div>
                    <div class="row">
                        <div class="col-12 d-none d-lg-block py-4">
                            <div class="px-4 dark-theme">
                                <status [userStatus]="userStatus" [activitiesCount]="activitiesCount">
                                </status>
                            </div>
                        </div>
                    </div>
                    <div class="row py-4">
                        <div class="col-12">
                            <h3 class="pb-3"><i>About {{user.firstName}}</i></h3>
                            <div class="text-large">
                                {{user.aboutYou}}
                            </div>
                        </div>
                    </div>
                    <div class="row py-4">
                        <div class="col-12">
                            <h3 class="pb-3"><i>About <span class="text-blue">{{user.company}}</span></i></h3>
                            <div class="text-large">
                                {{user.aboutYourCompany}}
                            </div>
                            <div class="pt-3"><a href="{{user.companyWebsite}}" target="_blank">Visit Website</a></div>
                        </div>
                    </div>
                </div>
                <div class="row py-4 align-items-center justify-content-end border-top" *ngIf="!ownProfile">
                    <div class="col-12 col-lg">
                        <h3><i>CONTACT {{user.firstName}}</i></h3>
                    </div>
                    <div class="col-12 col-lg-auto justify-self-end mt-3 mt-lg-0">
                        <a class="col-auto btn btn-secondary mr-2" href="mailto:{{user.emailAddress}}">Email</a>
                        <a class="col-auto btn btn-primary ml-2" target="_blank" href="#">Slack</a>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>